import store from "@/vuex/store";
import localStorageService from "../../../services/localStorage";

export const FEATURE_FLAG_KEY_OF_AUDITABILITY_OF_STUDY_CONFIGURATION = "tR03-1259_study_config_auditability";

export const isFeatureFlagEnabledForAuditabilityOfStudyConfiguration = () => {
  const featureFlags = localStorageService.getItem("featureFlags");
  store.dispatch("setFeatureFlags", featureFlags);
  const clientId = localStorageService.getItem("clientId");

  return store.getters.getIsFeatureFlagEnabled(FEATURE_FLAG_KEY_OF_AUDITABILITY_OF_STUDY_CONFIGURATION, clientId);
};
